export default function XSD_TextOnly() {
  return (
    <div>
      <h1>XSD_TextOnly</h1>
      <p>This is the XSD_TextOnly component.</p>
    </div>
  );
}